// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"91dee915","142":"2440158a","318":"56b24ad6"}[chunkId] + ".css";
};